import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, TextInput, Typography } from '@guildeducationinc/recess';
import ArrowBackIcon from '@guildeducationinc/recess/icons/ArrowBackIcon';
import ArrowForwardIcon from '@guildeducationinc/recess/icons/ArrowForwardIcon';
import { ClientHeader } from '@src/components/LoginForm/ClientHeader';
import { useForgotPassword } from '@src/hooks/useForgotPassword';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ClientWelcomeWrapper } from '../ClientWelcomeWrapper';
import styles from '../LoginForm/LoginForm.module.scss';
export const ForgotPassword = () => {
    const { t } = useLocale();
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const { forgotPassword } = useForgotPassword();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const validate = () => {
        if (!email || email.trim() === '') {
            setError(t('Email is required'));
            return false;
        }
        return true;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!validate())
            return;
        try {
            setSubmitting(true);
            const result = await forgotPassword(email);
            const { type, message } = result.data.forgotPassword;
            if (type === 'error') {
                setError(t(message));
            }
            else {
                setSubmitted(true);
                setMessage(t(message));
            }
        }
        catch (e) {
            setError(e.message);
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsx("div", { className: styles.loginForm, children: _jsxs("div", { className: styles.container, children: [_jsx(ClientHeader, {}), _jsx(ClientWelcomeWrapper, { children: _jsx("fieldset", { disabled: submitting, children: _jsxs("form", { noValidate: true, className: styles.form, onSubmit: handleSubmit, children: [_jsx(Typography, { variant: 'h1', children: t('Reset your password') }), !submitted && (_jsx(Typography, { variant: 'body1', gutterBottom: 'md', children: t('Reset your password description') })), _jsx(Alert, { hideClose: true, display: !!error, type: 'danger', className: 'margin--bottom_24', children: error }), _jsx(Alert, { hideClose: true, display: !!message, type: 'success', className: 'margin--bottom_24', children: message }), !submitted && (_jsx(TextInput, { disabled: submitting, label: t('Account email'), required: true, className: 'margin--auto', value: email, onChange: e => setEmail(e.target.value) })), _jsxs("div", { className: styles.actions, children: [submitted && (_jsx("div", { className: 'flex flexJustify--center', children: _jsxs(TrackableButton, { enText: 'Back to log in', tag: 'form', type: 'button', onClick: () => navigate('/auth/login'), className: 'flex gap-1 flexItems--center', children: [_jsx(ArrowBackIcon, { size: 16 }), " ", t('Back to log in')] }) })), _jsxs("div", { className: 'flex gap-3 flexJustify--center', children: [_jsx(Typography, { variant: 'body1', weight: '700', children: t("Don't have an account?") }), _jsxs(TrackableButton, { btnType: 'link', enText: 'Sign up', tag: 'form', component: Link, to: '/auth/sign-up', "data-testid": 'signupButton', className: 'flex gap-1 flexItems--center', children: [t('Sign up'), " ", _jsx(ArrowForwardIcon, { size: 16 })] })] })] }), !submitted && (_jsxs("div", { className: 'flex w-full items-center mt-5', children: [_jsx("div", { className: 'flex-grow text-left', children: _jsxs(TrackableButton, { btnType: 'link', enText: 'Back to log in', tag: 'form', component: Link, to: '/auth/login', className: 'flex gap-1 flexItems--center', children: [_jsx(ArrowBackIcon, { size: 16 }), " ", t('Back to log in')] }) }), _jsx("div", { className: 'flex-grow text-right', children: _jsx(TrackableButton, { enText: 'Reset password', tag: 'form', type: 'submit', disabled: submitting, children: t('Reset password') }, 'submit') })] }))] }) }) })] }) }));
};
